import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CaricaDocumentoModel } from 'src/app/pages/documents/model/CaricaDocumentoModel';

@Component({
  selector: 'app-upl-doc-btn',
  templateUrl: './upl-doc-btn.component.html',
  styleUrls: ['./upl-doc-btn.component.scss']
})
export class UplDocBtnComponent implements OnInit {

  buttonStr = "Carica documento";
  @Input() numeroOrdine: string;
  @Input() type: string;
  @Output() insert_document = new EventEmitter<string>();

  target = "";

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
    this.target = this.router.url.substring(1, this.router.url.length) || "";
  }

  goToUploadDocument() {
    let dataModel: CaricaDocumentoModel = {
      file: null, tipologiaDocumento: null, listaOrdinePosizioneFasi: [{ numeroOrdine: this.numeroOrdine || null, internalStep: 0, idOrdine: null, posizioni: null, fasi: null }],
      listaCodiceNC: [{ codiceNC: null }],
      type: this.type || null
    }
    sessionStorage.setItem('dataModel', JSON.stringify(dataModel));
    sessionStorage.setItem('from', this.target);
    this.router.navigate(['upload-documenti'], { state: { dataModel } });
  }


}
